import { render, staticRenderFns } from "./BaseEditableTable.vue?vue&type=template&id=6681d8e4&scoped=true&"
import script from "./BaseEditableTable.vue?vue&type=script&lang=ts&"
export * from "./BaseEditableTable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseEditableTable.vue?vue&type=style&index=0&id=6681d8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681d8e4",
  null
  
)

export default component.exports